module.exports = __webpack_public_path__ + "static/img/service-user-ac.89d54982.png";